<script setup lang="ts">
const props = defineProps<{
  product: SingleProduct
}>()

const gradeOptions = computed<Options<string, { grades?: GradeCode[] }>>(() => {
  if (props.product.template === 'grunnskole') {
    return GRUNNSKOLE_GRADE_OPTIONS
  }

  switch (props.product.levelFilter) {
    case 'alle':
      return ALL_GRADE_OPTIONS
    case 'ungdomsskole':
      return UNGDOMSSKOLE_GRADE_OPTIONS
    case 'vgs':
    default:
      return VGS_GRADE_OPTIONS
  }
})

const showFilter = computed(() => props.product.variants.length >= 4)
</script>

<template>
  <article class="bg-white text-(--color)">
    <header class="w-full bg-(--background)">
      <slot name="hero" />
    </header>

    <UContainer v-if="showFilter">
      <UiProductsFilter
        :product="product"
        :filter-key="product.levelFilter === 'alle' ? 'level' : 'grade'"
        :grade-options="gradeOptions"
      />
    </UContainer>

    <IconsArrowsDownLong v-else class="mx-auto w-full translate-y-[-35%] fill-(--accent-color)" />

    <UiProductsVariantsAccordion
      :default-open="!showFilter"
      :product="product"
      :grade-options="gradeOptions"
    />
  </article>
</template>
